import { useState } from "react";
import { TopBarComponent } from "./TopBar";

export function TopBarWrapper() {
    return <TopBarComponent/>;
}
